import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useEffect, useState } from "react";
import Btn from "../../shared/button/Btn";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { showModal } from "../../../features/modal/modalSlice";
import { getDatee } from "../../../helper/getDatee";
import { getTime } from "../../../helper/getTime";
import { calcSeferSuresi } from "../../../helper/calcSeferSuresi";
import dateConverter from "../../../helper/dateConverter";
import SmallSpinner from "../../shared/spinners/SmallSpinner";
import InputNumberNew from "../../shared/input/new/InputNumberNew";
import InputText from "../../shared/input/new/InputText";
import InputSelect from "../../shared/input/new/InputSelect";
import InputCityTown from "../../shared/input/new/InputCityTown";
import InputDate from "../../shared/input/new/InputDate";
import InputTime from "../../shared/input/new/InputTimeNew";
import locationData from "../../../utils/locationData/locationOptions";
import {tasimaTuruOptions,yukunTuruOptions, bozulabilirGidaTuruOptions, normalYukBirimi, tehlikeliYukBirimi,tehlikeliMaddeTasimaTuruOptions} from "../../../utils/UETDSOptions"
import { unCodes } from "../../../utils/un";
import PageTopTitle from "../../shared/PageTopTitle";
import { addUETDS, addUETDSDanger } from "../../../features/admin/adminSlice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 800px;
    height: 600px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;
    overflow: auto;
    padding-block: 30px;
    
      .col{
        margin: 0 auto;
        padding: 10px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .row{
            width: 100%;
            margin-block: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            div{
                width: 500px;
            }
        }
        .error{
            color: var(--color-main);
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            margin-bottom: 5px;
            width: 18%;
        }
        .error-un{
            color: var(--color-main);
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            margin-bottom: 5px;
        }
    }

    .message-container{
      height: auto;
      display: flex;
      gap: 10px;
      margin-left: 50px;
      p{
          width: max-content;
          background-color: ${({isOkay})=> isOkay ?"#0EAC00": "#E85446"};
          padding:10px 30px;
          border: 1px solid;
          border-color: ${({isOkay})=> isOkay ?"#0EAC00": "#E85446"};
          border-radius: 5px;
          font-size: 16px;
          color: white;
          font-weight: var(--font-weight-md);
      }
    }

    .button-grp{
        padding: 5px 10px;
        display: flex;
        gap: 10px;
        margin:30px;
    }
}
`;

const CreateUETDSForLogisticModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  const {isLoadingCreateUETDS} = useSelector(state => state.admin)
    const [tasimaTuru, setTasimaTuru] = useState({
        value:2,
        text:"Normal Yük"
    })
    const [yuklemeLocation, setYuklemeLocation] = useState(null)
    const [bosaltmaLocation, setBosaltmaLocation] = useState(null)
    const [tehlikeliMaddeTasimaTuru, setTehlikeliMaddeTasimaTuru] = useState(null)

    const [yukCinsAdi, setYukCinsAdi] = useState(null)
    const [bozulabilirGidaTuru, setBozulabilirGidaTuru] = useState(null)
    const [yukBirimi, setyukBirimi] = useState(null)

    //! eğer yük tehlikeli Yük ise un code lardan un coda karşılık gelen tehlikeli Yük ismini bulacak
    const [dangerousItemName, setDangerousItemName] = useState(null)
    const [isValidUnId, setIsValidUnId] = useState(false)

    const [isSubmitted, setIsSubmitted] = useState(false)
    const [isOkay, setIsOkay] = useState(false)
    const [message, setMessage] = useState("")

    const [uetdsValues, setUetdsValues] = useState({
        plaka1:"",
        plaka2:"",
        tcKimlikNo1:"",

        yuklemeTarihi: getDatee(),
        yuklemeSaati: getTime(),
        seferSuresi:"",
        bosaltmaTarihi:"",
        bosaltmaSaati:"",

        gondericiUnvan:"",
        gondericiVergiNo:"",
        aliciUnvan:"",
        aliciVergiNo:"",

        yukBirimi:null,
        yukMiktarı:"",
        tasimaBedeli:"",

        unId:""
    })

    const handleChange = (e) => {
        setUetdsValues((prev) => ({...prev, [e?.target?.name]: e?.target?.value}))
    }

    useEffect(()=> {
        if(uetdsValues.unId){
            const dangerousItem = unCodes.find((item)=> {
                // eslint-disable-next-line
                return item["BAKANLIK_KOD"] == uetdsValues.unId
            })
            if(dangerousItem){
                setDangerousItemName(dangerousItem["ORİJİNAL İSİM"])
                setIsValidUnId(true)
            }
            else{
                //! burada bu uyarı verildiğinde aynı zamanda input un border ı da kırmızı olabilir.
                setDangerousItemName("Lütfen geçerli bir UN kodu girin.")
                setIsValidUnId(false)
            }

        }
    },[uetdsValues.unId])

    useEffect(()=> {
        if(uetdsValues.seferSuresi < 1 && uetdsValues.seferSuresi !== ""){
          setUetdsValues((prev)=> ({...prev, seferSuresi: 1}))
        }
        if(uetdsValues.seferSuresi > 48){
          setUetdsValues((prev)=> ({...prev, seferSuresi: 48}))
        }
    },[uetdsValues.seferSuresi])

    useEffect(()=> {
        if (uetdsValues.seferSuresi){
        setUetdsValues((prev)=> ({...prev, bosaltmaTarihi: calcSeferSuresi(parseInt(uetdsValues.seferSuresi), uetdsValues.yuklemeTarihi, uetdsValues.yuklemeSaati).date, bosaltmaSaati: calcSeferSuresi(parseInt(uetdsValues.seferSuresi), uetdsValues.yuklemeTarihi, uetdsValues.yuklemeSaati).time}))
        }
        else{
          setUetdsValues((prev)=> ({...prev, bosaltmaTarihi: calcSeferSuresi(0).date, bosaltmaSaati: calcSeferSuresi(0).time}))
        }
    },[uetdsValues.seferSuresi, uetdsValues.yuklemeTarihi, uetdsValues.yuklemeSaati])

    useEffect(()=> {
        if(isSubmitted){
          if(tasimaTuru.text === "Tehlikeli Yük"){
            if(!tasimaTuru?.value || !uetdsValues.plaka1 || !uetdsValues.tcKimlikNo1 || !uetdsValues.yuklemeTarihi || !uetdsValues.yuklemeSaati || !uetdsValues.gondericiUnvan || !uetdsValues.gondericiVergiNo || !uetdsValues.aliciUnvan || !uetdsValues.aliciVergiNo || !yuklemeLocation || !bosaltmaLocation || !uetdsValues.bosaltmaTarihi || !uetdsValues.bosaltmaSaati || !yukBirimi?.value || !uetdsValues.yukMiktarı || !tehlikeliMaddeTasimaTuru?.value || !uetdsValues.unId){
                setMessage(`Lütfen doldurması zorunlu alanları doldurun.`)
                setIsOkay(false)
            }
      
            else{
              if(!isValidUnId){
                setMessage(`Lütfen geçerli bir UN kodu giriniz.`)
                setIsOkay(false)
              }
              else{
                setMessage("Yük kaydını Oluşturabilirsiniz.")
                setIsOkay(true)
              }
            }
        }
      
        else if( tasimaTuru.text === "Normal Yük"){
            if(!tasimaTuru?.value || !uetdsValues.plaka1 || !uetdsValues.tcKimlikNo1 || !uetdsValues.yuklemeTarihi || !uetdsValues.yuklemeSaati || !uetdsValues.gondericiUnvan || !uetdsValues.aliciUnvan || !yuklemeLocation || !bosaltmaLocation || !uetdsValues.bosaltmaTarihi|| !uetdsValues.bosaltmaSaati|| !yukCinsAdi || !yukBirimi?.value || !uetdsValues.yukMiktarı){
                setMessage(`Lütfen doldurması zorunlu alanları doldurun.`)
                setIsOkay(false)
            }
      
            else{
              setMessage("Yük kaydını Oluşturabilirsiniz.")
              setIsOkay(true)
            }
        }
        }
      },[tasimaTuru?.value, uetdsValues.plaka1, uetdsValues.tcKimlikNo1, uetdsValues.yuklemeTarihi, uetdsValues.yuklemeSaati, uetdsValues.gondericiUnvan, uetdsValues.gondericiVergiNo, uetdsValues.aliciUnvan, uetdsValues.aliciVergiNo, yuklemeLocation, bosaltmaLocation, uetdsValues.bosaltmaTarihi, uetdsValues.bosaltmaSaati, yukBirimi?.value, uetdsValues.yukMiktarı, tehlikeliMaddeTasimaTuru?.value, uetdsValues.unId, yukCinsAdi?.value, isSubmitted,isValidUnId])

      const yuklemeCityTown = yuklemeLocation?.location?.split("/")
      const bosaltmaCityTown = bosaltmaLocation?.location?.split("/")

      const yuklemeIlAdi = yuklemeCityTown ? yuklemeCityTown[1] : null
      const yuklemeIlceAdi = yuklemeCityTown ? yuklemeCityTown[0] : null
      const bosaltmaIlAdi = bosaltmaCityTown ? bosaltmaCityTown[1] : null
      const bosaltmaIlceAdi = bosaltmaCityTown ? bosaltmaCityTown[0] : null
      
    const handleSubmit = () => {
        setIsSubmitted(true)
        if(tasimaTuru.text === "Tehlikeli Yük"){
            if(!tasimaTuru?.value || !uetdsValues.plaka1 || !uetdsValues.tcKimlikNo1 || !uetdsValues.yuklemeTarihi || !uetdsValues.yuklemeSaati || !uetdsValues.gondericiUnvan || !uetdsValues.gondericiVergiNo || !uetdsValues.aliciUnvan || !uetdsValues.aliciVergiNo || !yuklemeLocation || !bosaltmaLocation || !uetdsValues.bosaltmaTarihi|| !uetdsValues.bosaltmaSaati|| !yukBirimi?.value || !uetdsValues.yukMiktarı || !tehlikeliMaddeTasimaTuru?.value || !uetdsValues.unId){
                setMessage("Lütfen doldurması zorunlu alanları doldurun.")
                return
            }else{
                if(!isValidUnId){
                  setMessage(`Lütfen geçerli bir UN kodu giriniz.`)
                  return
                }
            }
        }

        else if( tasimaTuru.text === "Normal Yük"){
            if(!tasimaTuru?.value || !uetdsValues.plaka1 || !uetdsValues.tcKimlikNo1 || !uetdsValues.yuklemeTarihi || !uetdsValues.yuklemeSaati || !uetdsValues.gondericiUnvan || !uetdsValues.aliciUnvan || !yuklemeLocation || !bosaltmaLocation || !uetdsValues.bosaltmaTarihi|| !uetdsValues.bosaltmaSaati|| !yukCinsAdi?.value || !yukBirimi?.value || !uetdsValues.yukMiktarı){
                setMessage("Lütfen doldurması zorunlu alanları doldurun.")
                return
            }
        }

        delete uetdsValues.seferSuresi

        const dataa={
            ...uetdsValues,

            //! date leri us formatından tr ye aktarmak için
            yuklemeTarihi: dateConverter(uetdsValues.yuklemeTarihi, "tr-2"),
            bosaltmaTarihi: dateConverter(uetdsValues.bosaltmaTarihi, "tr-2"),

            //! selected ones
            yuklemeIlAdi: yuklemeIlAdi,
            yuklemeIlceAdı: yuklemeIlceAdi,
            bosaltmaIlAdi: bosaltmaIlAdi,
            bosaltmaIlceAdı: bosaltmaIlceAdi,
            yukCinsAdi: tasimaTuru.value === 1 ? "" : yukCinsAdi.text,
            yukCinsId: tasimaTuru.value === 1 ? 999 : yukCinsAdi.value,
            yukBirimi: yukBirimi.value,
            tehlikeliMaddeTasimaTuru: tasimaTuru.value === 2 ? "" : tehlikeliMaddeTasimaTuru.value,
            tasimaTuruKodu: tasimaTuru.value,

            //! il ve ilçelerin mernis kodlarına ulaşmak için
            yuklemeIlMernisId: yuklemeLocation?.cityId,

            yuklemeIlceMernisKodu: yuklemeLocation?.townId,

            bosaltmaIlMernisKodu: bosaltmaLocation?.cityId,

            bosaltmaIlceMernisKodu: bosaltmaLocation?.townId,

            //! static benim elle koyduğum
            bosaltmaUlkeKodu: "TR",
            yuklemeUlkeKodu: "TR"
        }

        // if(tasimaTuru.value === 1){
        //     dispatch(addUETDSDanger(dataa))
        // }
        // if(tasimaTuru.value === 2){
        //     dispatch(addUETDS(dataa))
        // }
    }

    const clearAllStates = () => {
        setUetdsValues({
            plaka1:"",
            plaka2:"",
            tcKimlikNo1:"",
    
            yuklemeTarihi: getDatee(),
            yuklemeSaati: getTime(),
            seferSuresi:"",
            bosaltmaTarihi:"",
            bosaltmaSaati:"",
    
            gondericiUnvan:"",
            gondericiVergiNo:"",
            aliciUnvan:"",
            aliciVergiNo:"",
    
            yukBirimi:null,
            yukMiktarı:"",
            tasimaBedeli:"",
    
            unId:""
        })

        setMessage("")
        setIsOkay(null)
        setIsSubmitted(null)
        setIsValidUnId(null)
        setDangerousItemName(null)
        setyukBirimi(null)
        setBozulabilirGidaTuru(null)
        setYukCinsAdi(null)
        setTehlikeliMaddeTasimaTuru(null)
        setBosaltmaLocation(null)
        setYuklemeLocation(null)
        setTasimaTuru({
            value:2,
            text:"Normal Yük"
        })
    }


  return (
    <Container isOkay={isOkay} onClick={() => {dispatch(handleActiveSelect(null)); dispatch(showModal(null)) }}>
      <div onClick={(e) => e.stopPropagation()} className="modal">
        <PageTopTitle title={"U-ETDS Yük Bildirimi Ekle"} position='sticky'/>
        <div className="col">
            <div className="row">
                <InputSelect data={tasimaTuru?.text} setData={setTasimaTuru} labelText={"Taşıma Türü (Zorunlu)"} name={"tasimaTuru"} initialOptions={tasimaTuruOptions} />
                {
                    isSubmitted === true && !tasimaTuru &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputText data={uetdsValues?.plaka1} setData={(e) => handleChange(e)} labelText={"Plaka (Zorunlu)"} name={"plaka1"} />
                {
                    isSubmitted === true && !uetdsValues?.plaka1 &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputText data={uetdsValues?.plaka2} setData={(e) => handleChange(e)} labelText={"Y.Römork - Römork Plakası"} name={"plaka2"} />
            </div>
            <div className="row">
                <InputText data={uetdsValues?.tcKimlikNo1} setData={(e) => handleChange(e)} labelText={"Sürücü TC No (Zorunlu)"} name={"tcKimlikNo1"} />
                {
                    isSubmitted === true && !uetdsValues?.tcKimlikNo1 &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputDate data={uetdsValues?.yuklemeTarihi} setData={(e) => handleChange(e)} labelText={"Yükleme Tarihi (Zorunlu)"} name={"yuklemeTarihi"} />

            </div>
            <div className="row">
                <InputTime data={uetdsValues?.yuklemeSaati} setData={(e) => handleChange(e)} labelText={"Yükleme Saati (Zorunlu)"} name={"yuklemeSaati"} />

            </div>
            <div className="row">
                <InputText data={uetdsValues?.seferSuresi} setData={(e) => handleChange(e)} labelText={"Tahmini Sefer Süresi"} name={"seferSuresi"} />

            </div>
            <div className="row">
                <InputDate data={uetdsValues?.bosaltmaTarihi} setData={(e) => handleChange(e)} labelText={"Boşaltma Tarihi (Zorunlu)"} name={"bosaltmaTarihi"} />

            </div>
            <div className="row">
                <InputTime data={uetdsValues?.bosaltmaSaati} setData={(e) => handleChange(e)} labelText={"Boşaltma Saati (Zorunlu)"} name={"bosaltmaSaati"} />

            </div>
            <div className="row">
                <InputNumberNew data={uetdsValues?.gondericiVergiNo} setData={(e) => handleChange(e)} labelText={"Gönderen Vergi Numarası (Zorunlu)"} name={"gondericiVergiNo"} />
                {
                    isSubmitted === true && tasimaTuru.text === "Tehlikeli Yük" && !uetdsValues?.gondericiVergiNo &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputText data={uetdsValues?.gondericiUnvan} setData={(e) => handleChange(e)} labelText={"Gönderen Adı / Ünvanı (Zorunlu)"} name={"gondericiUnvan"} />
                {
                    isSubmitted === true &&  !uetdsValues?.gondericiUnvan &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputNumberNew data={uetdsValues?.aliciVergiNo} setData={(e) => handleChange(e)} labelText={"Alıcı Vergi Numarası"} name={"aliciVergiNo"} />
                {
                    isSubmitted === true && tasimaTuru.text === "Tehlikeli Yük" && !uetdsValues?.aliciVergiNo &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputText data={uetdsValues?.aliciUnvan} setData={(e) => handleChange(e)} labelText={"Alıcı Adı / Ünvanı (Zorunlu)"} name={"aliciUnvan"} />
                {
                    isSubmitted === true  && !uetdsValues?.aliciUnvan &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputCityTown data={yuklemeLocation?.location} setData={setYuklemeLocation} initialOptions={locationData} labelText={"Yükleme İl / İlçe (Zorunlu)"} name={"yuklemeLocation"} />
                {
                    isSubmitted === true  && !yuklemeLocation &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputCityTown data={bosaltmaLocation?.location || ""} setData={setBosaltmaLocation} initialOptions={locationData} labelText={"Boşaltma İl / İlçe (Zorunlu)"} name={"bosaltmaLocation"} />
                {
                    isSubmitted === true  && !bosaltmaLocation &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            {tasimaTuru?.text === "Normal Yük" && 
                <div className="row">
                    <InputSelect data={yukCinsAdi?.text  || ""} setData={setYukCinsAdi} labelText={"Yükün Türü (Zorunlu)"} name={"yukCinsAdi"} initialOptions={yukunTuruOptions} />
                {
                    isSubmitted === true &&  !yukCinsAdi?.text &&
                    <span className="error">Zorunlu Alan</span>
                }
                </div>
            }
            {
                yukCinsAdi?.value === 202 &&
                <div className="row">
                    <InputSelect data={bozulabilirGidaTuru?.text} setData={setBozulabilirGidaTuru} labelText={"Bozulabilir Gıda Türü (Zorunlu)"} name={"bozulabilirGidaTuru"} initialOptions={bozulabilirGidaTuruOptions} />
                </div>
            }
            {
                tasimaTuru?.text === "Normal Yük" ?
                <div className="row">
                    <InputSelect data={yukBirimi?.text} setData={setyukBirimi} labelText={"Yükün Birimi (Zorunlu)"} name={"yukBirimi"} initialOptions={normalYukBirimi} />
                {
                    isSubmitted === true && tasimaTuru.text === "Normal Yük" && !yukBirimi?.text &&
                    <span className="error">Zorunlu Alan</span>
                }
                </div>
                :
                <div className="row">
                    <InputSelect data={yukBirimi?.text} setData={setyukBirimi} labelText={"Yükün Birimi (Zorunlu)"} name={"yukBirimi"} initialOptions={tehlikeliYukBirimi} />
                {
                    isSubmitted === true && tasimaTuru.text === "Tehlikeli Yük" && !yukBirimi?.text &&
                    <span className="error">Zorunlu Alan</span>
                }
                </div>
            }

            {tasimaTuru?.value === 1 && 
                <div className="row">
                    <InputSelect data={tehlikeliMaddeTasimaTuru?.text} setData={setTehlikeliMaddeTasimaTuru} labelText={"Tehlikeli Madde Taşıma Şekli  (Zorunlu)"} name={"yukCinsAdi"} initialOptions={tehlikeliMaddeTasimaTuruOptions} />
                {
                    isSubmitted === true && tasimaTuru.text === "Tehlikeli Yük" && !tehlikeliMaddeTasimaTuru?.text &&
                    <span className="error">Zorunlu Alan</span>
                }
                </div>
            }
            {tasimaTuru?.value === 1 && 
                <div className="row">
                    <InputText data={uetdsValues?.unId} setData={(e) => handleChange(e)} labelText={"Un Kodu (Zorunlu)"} name={"unId"} />
                {
                    isSubmitted === true && tasimaTuru.text === "Tehlikeli Yük" && !tehlikeliMaddeTasimaTuru?.text &&
                    <span className="error">Zorunlu Alan</span>
                }
                </div>
            }
            {
                (uetdsValues.unId && tasimaTuru.text === "Tehlikeli Yük") && 
                <div className="row">
                    <InputText disabled={true} data={dangerousItemName} labelText={"Tehlikeli Madde"} />
                 </div>
            }

            <div className="row">
                <InputNumberNew data={uetdsValues?.yukMiktarı} setData={(e) => handleChange(e)} labelText={"Yükün Miktarı (Zorunlu)"} name={"yukMiktarı"} />
                {
                    isSubmitted === true &&  !uetdsValues?.yukMiktarı &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            <div className="row">
                <InputNumberNew data={uetdsValues?.tasimaBedeli} setData={(e) => handleChange(e)} labelText={"Nakliye Bedeli"} name={"tasimaBedeli"} />
            </div>

        </div>

        {
          message &&
          <div className="message-container">
            <p>{message}</p>
          </div>
        }

        <div className="button-grp">
          <Btn color={"#fff"} bgColor={"#E85446"} width="200px" radius={"10px"} padding="0 10px" handleClick={handleSubmit}>{isLoadingCreateUETDS ? <SmallSpinner  size={"20px"} color={"#fff"} bgColor={"#9ded9a"}/>: "Kaydet"}</Btn>
          {/* <Btn color={"#E85446"} bgColor={"transparent"} width="200px" radius={"10px"} padding="0 10px" handleClick={()=>{}}>Kaydet ve U-ETDS Gönder</Btn> */}
          <Btn color={"#E85446"} bgColor={"transparent"} width="200px" radius={"10px"} padding="0 10px" handleClick={clearAllStates}>Temizle</Btn>
        </div>
      </div>
    </Container>
  )
};

export default CreateUETDSForLogisticModal;
